import { Outlet, useNavigate } from "react-router-dom";

import {
  AdminBody,
  AdminHeader,
  AdminLayoutWrapper,
  Avatar,
  ContentWrapper,
  DocumentNoteHeader,
  DropdownItem,
  DropdownItemLogout,
  DropdownMenu,
  HeaderAdmin,
  HeaderLogo,
  Sidebar,
  SidebarItem,
  SidebarMenu,
  UserMenuWrapper,
  UserName,
  UserTrigger,
} from "./AdminLayout_Style";
import { useEffect, useState } from "react";
import ToastContainer from "./notification/NotificationBell";
import { jwtDecode } from "jwt-decode";
import { ITokenPayload } from "./models/user";

const AdminLayout = () => {
  const navigate = useNavigate();
  const [showMenu, setShowMenu] = useState(false);
  const [user, setUser] = useState<ITokenPayload | null>();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const decoded = jwtDecode<any>(token);

      const user: ITokenPayload = {
        ...decoded,
        isAdmin: decoded.isAdmin === true || decoded.isAdmin === "True",
      };

      if (!user.isAdmin) navigate("../admin-login");
      setUser(user);
    } else {
      navigate("../admin-login");
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    setUser(null);
    setShowMenu(false);
    navigate("../admin-login");
  };

  return (
    <AdminLayoutWrapper>
      {/* Header */}
      <AdminHeader>
        <HeaderLogo>My Admin</HeaderLogo>
        <HeaderAdmin>
          <UserMenuWrapper>
            <UserTrigger onClick={() => setShowMenu((v) => !v)}>
              <Avatar src={user?.avatar} />
              <UserName>{user?.fullName}</UserName>
            </UserTrigger>

            {showMenu && (
              <DropdownMenu>
                <DropdownItem>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-person"
                    viewBox="0 0 16 16">
                    <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z" />
                  </svg>
                  {user?.email}
                </DropdownItem>
                <DropdownItemLogout onClick={() => handleLogout}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-box-arrow-right"
                    viewBox="0 0 16 16">
                    <path
                      fill-rule="evenodd"
                      d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0z"
                    />
                    <path
                      fill-rule="evenodd"
                      d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z"
                    />
                  </svg>
                  Đăng xuất
                </DropdownItemLogout>
              </DropdownMenu>
            )}
          </UserMenuWrapper>
        </HeaderAdmin>
      </AdminHeader>

      {/* Body */}
      <AdminBody>
        {/* Sidebar */}
        <Sidebar>
          <SidebarMenu>
            <SidebarItem onClick={() => navigate("/admin/dashboard")}>
              Dashboard
            </SidebarItem>
            <SidebarItem onClick={() => navigate("/admin/user")}>
              User
            </SidebarItem>
            <SidebarItem onClick={() => navigate("/admin/file")}>
              File
            </SidebarItem>
            <SidebarItem onClick={() => navigate("/admin/page")}>
              Page
            </SidebarItem>
            <SidebarItem onClick={() => navigate("/admin/blog")}>
              Blog
            </SidebarItem>
            <SidebarItem onClick={() => navigate("/admin/support")}>
              Support Policies
            </SidebarItem>
            <SidebarItem onClick={() => navigate("/admin/tone")}>
              Tone
            </SidebarItem>
            <SidebarItem onClick={() => navigate("/admin/setting")}>
              Setting
            </SidebarItem>

            {/* 
            <SidebarItem onClick={() => navigate("/admin/seo")}>
              Seo
            </SidebarItem>

            <SidebarItem onClick={() => navigate("/admin/content")}>
              Content
            </SidebarItem> */}
          </SidebarMenu>
        </Sidebar>

        {/* Content */}
        <ContentWrapper>
          <Outlet />
        </ContentWrapper>
        <ToastContainer />
      </AdminBody>
    </AdminLayoutWrapper>
  );
};

export default AdminLayout;
